"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _alloyReactIllustration = _interopRequireDefault(require("@adsk/alloy-react-illustration"));

var _alloyReactTheme = _interopRequireDefault(require("@adsk/alloy-react-theme"));

var _DropZone = _interopRequireDefault(require("./DropZone"));

var _alloyReactHelpers = require("@adsk/alloy-react-helpers");

var _UploadItemCollection = _interopRequireDefault(require("./UploadItemCollection"));

var _file = require("../../util/file");

var _flags = _interopRequireDefault(require("../../util/flags"));

var _PlangridLaunchDarklyProvider = require("../../util/PlangridLaunchDarklyProvider");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const TWENTY_MB = 20971520;
const ONE_GB = 1073741824;

const isOverSizeLimit = file => {
  return file.type.includes("video") && file.size > ONE_GB || file.type.includes("image") && file.size > TWENTY_MB;
}; // const UploadButton = styled.div`
// text-align: center;
// `;
// const UploadButtonsContainer = styled.div`
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   margin: auto;
// `;
// const CloudUploadButton = styled.div`
//   margin-left: 32px;
// `;


const StyledIllustration = (0, _styledComponents.default)(_alloyReactIllustration.default)`
  padding: 12px;
`;
const DropZoneText = _styledComponents.default.p`
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
`;
const DropZoneLinkText = _styledComponents.default.a`
  line-height: 20px;
  font-weight: 450;
  font-style: normal;
  color: ${_alloyReactTheme.default.colors.adskBlue700};
  &:hover {
    cursor: pointer;
  }
`;

const MediaUploadBody = ({
  uploadHandler,
  uploads,
  removeHandler
}) => {
  const {
    T
  } = (0, _alloyReactHelpers.useLocale)(({
    locale
  }) => require(`../i18n/${locale}.json`));
  const fileInputEl = (0, _react.useRef)(null);
  const handleFileUpload = (0, _react.useCallback)(files => {
    if (files.length > 0) {
      const filesToUpload = [];
      const filesErrored = [];

      for (let i = 0; i < files.length; i++) {
        if (isOverSizeLimit(files[i])) {
          filesErrored.push(files[i]);
        } else {
          filesToUpload.push(files[i]);
        }
      }

      uploadHandler(filesToUpload, filesErrored);
    }
  }, [uploadHandler]);
  const handleFileButtonUpload = (0, _react.useCallback)(e => {
    e.stopPropagation();
    const files = e.dataTransfer ? e.dataTransfer.files : e.target.files;
    handleFileUpload(files);
    e.target.value = "";
  }, [handleFileUpload]);
  const handleFileUploadButtonClick = (0, _react.useCallback)(e => {
    e.currentTarget.blur();
    fileInputEl.current && fileInputEl.current.click();
  }, []);
  const {
    value: allowHEIC
  } = (0, _PlangridLaunchDarklyProvider.usePlangridFeatureFlag)(_flags.default.PHOTO_HEIC, false);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_DropZone.default, {
    fileDropHandler: handleFileUpload
  }, uploads.length > 0 ? /*#__PURE__*/_react.default.createElement(_UploadItemCollection.default, {
    uploads: uploads,
    removeHandler: removeHandler
  }) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(StyledIllustration, {
    type: _alloyReactIllustration.default.TYPES.FOLDER_PHOTO_CLOSED_FIST_GREY
  }), /*#__PURE__*/_react.default.createElement(DropZoneText, null, T.translate("DRAG_FILE_HERE_OR")), /*#__PURE__*/_react.default.createElement(DropZoneLinkText, {
    onClick: handleFileUploadButtonClick
  }, T.translate("CHOOSE_FILE")))), /*#__PURE__*/_react.default.createElement("input", {
    style: {
      visibility: "hidden"
    },
    type: "file",
    ref: fileInputEl,
    name: "file",
    onChange: handleFileButtonUpload,
    multiple: true,
    accept: allowHEIC ? _file.SUPPORTED_TYPES_WITH_HEIC.join(",") : _file.SUPPORTED_TYPES.join(",")
  }));
};

var _default = MediaUploadBody;
exports.default = _default;